<template>
  <div class="wrapper">
    <div class="content">
      <h1>Gonzaller</h1>
      <p>Esta applicación require contraseña</p>
      <v-text-field
        label="token"
        type="text"
        v-model="token"
        clearable
        hide-details
        @keypress.enter="authenticate"
      ></v-text-field>
      <span style="font-size: 75%"><b>Pista:</b> ::</span>
      <br />
      <br />
      <v-btn @click="authenticate" flat block color="success">Submit</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: '',
      type: 'password',
    }
  },
  methods: {
    authenticate() {
      let t = this.token.toLowerCase()
      this.$store.commit('setToken', t)
      this.$router.push('/v2/edit/1')
    },
  },
  mounted() {
    this.token = this.$store.state.token
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 50%;
}
.content {
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
}
</style>
